import { authDomain } from '@auth';
import { useMutation } from '@tanstack/react-query';

export const useCheckEmail = () => {
  return useMutation((payload: authDomain.CheckEmailDto) => {
    return authDomain.authService.checkEmail(payload);
  });
};
